var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25071 7.55451C2.01986 7.55045 1.82749 7.49964 1.67359 7.40208C1.52374 7.30046 1.41237 7.17241 1.33947 7.01794C1.26657 6.85941 1.23822 6.69275 1.25442 6.51796C1.27062 6.3391 1.33137 6.17447 1.43667 6.02407C1.54197 5.86961 1.69789 5.74563 1.90444 5.65213L11.6243 1.15837C11.9038 1.03235 12.161 0.981543 12.3959 1.00593C12.6308 1.02626 12.8231 1.10959 12.973 1.25592C13.1228 1.3982 13.2119 1.58518 13.2403 1.81688C13.2727 2.04452 13.2241 2.30061 13.0945 2.58515L8.6294 12.3044C8.5322 12.5239 8.40463 12.6885 8.24668 12.7983C8.08873 12.9121 7.92066 12.9771 7.74246 12.9934C7.56426 13.0137 7.39619 12.9873 7.23824 12.9141C7.08029 12.8409 6.95271 12.7271 6.85552 12.5727C6.75832 12.4223 6.70972 12.2353 6.70972 12.0117L6.69757 7.66427C6.69757 7.59923 6.66517 7.56671 6.60037 7.56671L2.25071 7.55451Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.350c84f386429bfd6b513bd4a5535fd9.svg";
export { ForwardRef as ReactComponent };